module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms15e-detail3InfoDesc1"
    }
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_c('h4', [_c('u', [_vm._v(_vm._s(_vm.labels['HRAP31EC32']['90']))])])]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.detail3InfoDesc1Table,
      "data": _vm.detail,
      "addInlineEventBool": _vm.validateStaappr,
      "editInlineEventBool": true,
      "deleteInlineEventBool": true,
      "saveInlineEvent": _vm.callSave,
      "columnEvent": _vm.columnEvent,
      "deleteInlineBtnDisp": false,
      "saveInlineBtnDisp": _vm.validateStaappr
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18acb8c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms15e/detail3InfoDesc1.vue
// module id = 3596
// module chunks = 1